import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';

import { SportsWebBootstrapService } from './sports-web-bootstrap.service';

export const provideSportsWebBootstrap = () => runOnSportsWebInit(SportsWebBootstrapService);
